var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_config = require("cio-config");
var PathData = require("./../../svg/pathData.js");

var CopperPourData = function(net, layerIndex, isolation, rank, thermals, orphans, initShape){
    var self = this;

    this.makeObservableTreeNode();

    this.shape      = this.value("shape", true);
    this.layerIndex = this.value("layerIndex", true);
    this.net        = this.value("net", false);
    this.isolation  = this.value("isolation", true, cio_config.types.positive_float.validator);
    this.rank       = this.value("rank", true);
    this.thermals   = this.value("thermals", true);
    this.orphans    = this.value("orphans", true);

    this.geometry = this.cachedFunction("geometry",
        self._getGeometry,
        [[this.shape, this.shape.onBubble]]
    );

    this.copperPourPoly = lib_core.ObservableValue.createNewFunction();
    this.traceElementsMap = new lib_core.ObservableMap();


    this.outlineGeometry = this.cachedFunction("outlineGeometry",
       self._getSegmentedGeometry,
       [[this.shape, this.shape.onBubble]]
    );

    this.mesh = this.cachedFunction("mesh",
        function (precision) {
            return (new lib_geometry.TriangleMesh()).fromPolygon(this.outlineGeometry(precision), 34);
        },
        [this.outlineGeometry]
    );

    if(net !== undefined) this.net(net);
    if(layerIndex !== undefined) this.layerIndex(layerIndex);
    if(isolation !== undefined) this.isolation(isolation);
    if(thermals !== undefined) this.thermals(thermals);
    if(orphans !== undefined) this.orphans(orphans);
    if(rank !== undefined) this.rank(rank);
    if(initShape) this.shape(new PathData(new lib_geometry.Coord(0,0), 250, null, true)); // TODO
};
lib_core.mixin(CopperPourData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(CopperPourData, "CopperPour");

module.exports = CopperPourData;

CopperPourData.prototype.connectedElements = function() {
    // TODO
};

CopperPourData.prototype._getGeometry = function () {
    var poly = this.shape().geometry();
    return poly;
};

CopperPourData.prototype.boundingBox = function () {
    return this.geometry().getBB();
};

CopperPourData.prototype.segmentedGeometry = function () {
    return this._getSegmentedGeometry.apply(this, arguments);
};

CopperPourData.prototype.bufferedSegmentedGeometry = function (precision, layerIndex, layerType, bufferSize) {
    if(layerIndex === this.layerIndex()) {
        return this.segmentedGeometry(precision, layerIndex, layerType).buffer(bufferSize);
    }
};

CopperPourData.prototype._getSegmentedGeometry = function (precision, layerIndex) {
    if(this.layerIndex() === layerIndex) {
        var poly = null;
        if(this.copperPourPoly && this.copperPourPoly()) poly = this.copperPourPoly();
        else if(this.shape()) poly = this.shape().segmentedGeometry(precision);
        return poly;
    } else {
        return null;
    }
};

CopperPourData.prototype.move = function (vec) {
    return this.shape() && this.shape().move(vec);
};

CopperPourData.prototype.rotate = function (angle) {
    return this.shape() && this.shape().rotate(angle);
};

CopperPourData.prototype.flip = function (flipline) {
    return this.shape() && this.shape().flip(flipline);
};

CopperPourData.prototype.getLayers = function () {
    var result = new lib_core.Collections.HashSet();
    result.add(this.layerIndex());
    return result;
};
